export default (() => {
  let footNotePrefix = '';

  if (window.innerWidth <= 1024) {
    footNotePrefix = '-small';
  }

  return footNotePrefix;
})();
